<template>
  <div class="technology-container ">
    <div class="image-container height386">
      <img src="@/assets/cpjs/banner_cpjs.png" />
    </div>
    <div class="height540">
      <div class="section1 width1200">
        <img src="@/assets/cpjs/pic01.png" />
        <h1>发音能力评估</h1>
        <h2>Pronunciation Evaluation</h2>
        <div>
          针对口语的单词、句子、段落进行多维度英文口语评测，为学习者发音纠错提供依据。
        </div>
      </div>
    </div>
    <div class="height600 bgf0">
      <div class="section2 width1200">
        <img src="@/assets/cpjs/pic02.png" />
        <h1>语用能力评估</h1>
        <h2>Communication Evaluation</h2>
        <div>
          通过设计任务型情景，提供有限选择，打造智能对话引擎，考察学习者完成任务的程度，评估学习者的语用能力。
        </div>
      </div>
    </div>

    <div class="height540">
      <div class="section3 width1200">
        <img src="@/assets/cpjs/pic03.png" />
        <h1>表达能力评估</h1>
        <h2>Presentation Evaluation</h2>
        <div>
          全面考察内容、发音、语法、流利度。题型包括话题简述、看图说话、口头作文、故事复述等开放性题型。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style lang="less" scoped>
.technology-container {
  .height540 {
    height: 540px;
 
  }
  .height600 {
    height: 600px;
 
  }
  .width1200 {
    width: 1200px;
    margin: 0 auto;
  }
  .bgf0 {
    background-color: #f0f0f0;
  }
  .image-container {
    background-color: #0066cc;
    text-align: center;
  }
  .section1 {
    position: relative;
    h1 {
      // position: absolute;
      color: #344f97;
      font-size: 38px;
      line-height: 48px;
      padding-top: 103px;
      text-align: center;
    }
    h2 {
      font-size: 16px;
      line-height: 48px;
      color: #666666;
      text-align: center;
    }
    div {
      font-size: 16px;
      line-height: 35px;
      color: #333333;
      text-align: center;
    }
    img {
      position: absolute;
      left: 16px;
      top: 239px;
    }
  }

  .section2 {
    position: relative;
    h1 {
      color: #344f97;
      font-size: 38px;
      line-height: 48px;
      padding-top: 50px;
      text-align: center;
    }
    h2 {
      font-size: 16px;
      line-height: 48px;
      color: #666666;
      text-align: center;
    }
    div {
      font-size: 16px;
      line-height: 35px;
      color: #333333;
      text-align: center;
    }
    img {
      position: absolute;
      left: 65px;
      top: 184px;
    }
  }
  .section3 {
    position: relative;
    margin: 0 auto;
    h1 {
      // position: absolute;
      color: #344f97;
      font-size: 38px;
      line-height: 78px;
      margin-top: 123px;
      text-align: center;
    }
    h2 {
      font-size: 16px;
      line-height: 48px;
      color: #666666;
      text-align: center;
    }
    div {
      font-size: 16px;
      line-height: 35px;
      color: #333333;
      text-align: center;
      margin-top: 30px;
    }
    img {
      position: absolute;
      left: 80px;
      top: 228px;
    }
  }
}
</style>
